import { useContext } from "react";
import ScreenTextContext from "../contexts/ScreenTextContext";

/**
 * Cleans up code for getting screenText for easier reuse
 */
export function useScreenText(property) {
  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText[property] ) {
    return {};
  }
  
  return screenText[property];
}